import * as React from 'react';

import {AiSummaryTruncated} from '../../../../external-meetings/tables/ai-summary-truncated';
import {useLeadSummary} from '../../../../lead/shared/graphql/hooks/use-lead-summary';

type Props = {
    entityId: string;
};

export function CellAiSummary(props: Props) {
    const {entitySummary, isLoading, regenerateSummary} = useLeadSummary(props.entityId);

    return (
        <AiSummaryTruncated
            summary={entitySummary}
            title='Summary'
            isGenerating={isLoading}
            entityId={props.entityId}
            onRefresh={regenerateSummary}
        />
    );
}
